export const contactEmailConstants = {
  HR: "hqs@patrickfire.com",
  JIMMY_DO: "jeremy@patrickfire.com",
  TEST_ADMIN: "wrg_test_admin@mailinator.com",
};
